import React, { createContext, useContext, useState, ReactNode } from 'react';

// Define types for route context
type RouteContextType = {
  route: string;
  navigate: (route: string) => void;
};

// Create the RouteContext
const RouteContext = createContext<RouteContextType | undefined>(undefined);

// Custom hook to use the RouteContext
export const useRoute = () => {
  const context = useContext(RouteContext);
  if (!context) {
    throw new Error('useRoute must be used within a RouteProvider');
  }
  return context;
};

// RouteProvider component to manage routes
export const RouteProvider = ({ children }: { children: ReactNode }) => {
  const [route, setRoute] = useState('APTDetails');

  const navigate = (route: string) => {
    setRoute(route);
  };

  return (
    <RouteContext.Provider value={{ route, navigate }}>
      {children}
    </RouteContext.Provider>
  );
};

// RouterView component to render based on current route
export const RouterView: React.FC<{ children: (props: { route: string }) => JSX.Element }> = ({ children }) => {
  const { route } = useRoute();

  return children({ route });
};
